import { SimpleBars } from '../../Common/Charts/SimpleBars';
import { useProductionTemporalChartsDataContext } from './hooks/useProductionTemporalChartsDataContext';

const MONTH_LABELS = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

export const ProductionByMonth = () => {
    const { chartData } = useProductionTemporalChartsDataContext();

    const porMes = chartData?.byMonth || {};
    const months = Object.keys(porMes).sort((a, b) => Number(a) - Number(b));
    const subtitles = months.map((month) => MONTH_LABELS[Number(month) - 1] || month);
    const values = months.map((month) => porMes[month]);

    return (
        <SimpleBars
            title={'Atendimentos por Mês'}
            values={values}
            subtitles={subtitles}
        />
    );
};
